"use client";

import Icon from "@ant-design/icons";

export const SolutionItemBox = ({
  color,
  size = "2em",
  margin = "4px",
}: {
  color: string;
  margin?: string;
  size?: string;
}) => (
  <div
    style={{
      display: "block",
      backgroundColor: color,
      border: "1px solid",
      borderRadius: "5px",
      borderColor: color,
      width: size,
      height: size,
      margin: margin,
      lineHeight: 0,
    }}
  ></div>
);
export const SolutionIcon = ({
  color,
  size = "2em",
  margin = "4px",
  icon,
  radius,
  ...props
}: Omit<React.ComponentProps<typeof Icon>, "size" | "margin"> & {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  color: string;
  radius?: boolean;
  size?: string;
  margin?: string;
}) => (
  <Icon
    component={icon}
    style={{
      display: "block",
      color: color,
      border: radius ? "1px solid" : "none",
      borderRadius: "5px",
      fontSize: size,
      margin: margin,
    }}
    {...props}
  />
);
